// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__21wrF","label":"LabeledBox_label__iMJzc"};